// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachmentChildren_root__2LUcy","periodWrapper":"AttachmentChildren_periodWrapper__3NgAk","eyeIcon":"AttachmentChildren_eyeIcon__28g3g"};